export default {
  title: {
    id: 'buyback_refurbisher_send_payment_modal_title',
    defaultMessage: 'Send payment',
  },
  confirmationMessage: {
    id: 'buyback_refurbisher_send_payment_modal_confirmation_message',
    defaultMessage: 'Are you sure you want to send the payment for this order?',
  },
  confirmButton: {
    id: 'buyback_refurbisher_send_payment_modal_confirm_button',
    defaultMessage: 'Yes, send payment',
  },
  declineButton: {
    id: 'buyback_refurbisher_send_payment_modal_decline_button',
    defaultMessage: 'No, don’t send',
  },
}
